import React, { Fragment } from "react";
import PropTypes from "prop-types";
import DealsCardItem from "./DealsCardItem";

const DealsContainer = ({ data, restUrl }) => {
    return (
        <Fragment>
            {data.map(dataItem => {
                return (
                    <DealsCardItem
                        dataItem={dataItem}
                        restUrl={restUrl}
                        key={dataItem.sku}
                    />
                );
            })}
        </Fragment>
    );
};

DealsContainer.defaultProps = {
    data: [],
    restUrl: ""
};

DealsContainer.propTypes = {
    data: PropTypes.array,
    restUrl: PropTypes.string
};

export default DealsContainer;
